import Api from '@/api/abstract';

export let CREATE = (params, successCallback, errorCallback) => {
    let url = `/user/mail`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let LIST = (params, successCallback, errorCallback) => {
    let url = `/user/mail?${params.payload.query}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let DETAIL = (params, successCallback, errorCallback) => {
    let url = `/user/mail/${params.payload.id}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let UPDATE = (params, successCallback, errorCallback) => {
    let url = `/user/mail/${params.payload.id}`;
    let data = params.payload.data;
    return Api.put(url, data).then(successCallback).catch(errorCallback);
};

export let DELETE = (params, successCallback, errorCallback) => {
    let url = `/user/mail/${params.payload.id}`;
    return Api.delete(url).then(successCallback).catch(errorCallback);
};
